import api from './api';

export const transactionService = {
  create: async (debtorId, transactionData) => {
    return await api.post(`/debtors/${debtorId}/transactions`, transactionData);
  },

  update: async (transactionId, updateData) => {
    return await api.put(`/transactions/${transactionId}`, updateData);
  },

  delete: async (transactionId) => {
    return await api.delete(`/transactions/${transactionId}`);
  }
};
